<template>
  <div class="c-post">
    <div class="c-msg" v-html="formatMsg(post.content.main)"></div>
    <div class="c-list-ttl">{{ $T('post.file.content') }}</div>
    <div class="c-tgt-files">
      <div class="c-tgt" v-for="(file, fid) in files">
        <v-btn
          class="c-btn"
          flat
          color="clr-black"
          @click="download(fid)"
          :disabled="isGuest || isExpired || preparing || loading"
          :loading="downloading[fid]"
        >
          <v-icon left>{{ toIcon(file.name) }}</v-icon>
          <span class="c-fname">{{ fileName(file.name) }}</span
          ><span v-if="fileExt(file.name)">.{{ fileExt(file.name) }}</span
          ><span class="c-fsize">({{ $utils.toFileSize(file.size) }})</span>
        </v-btn>
      </div>
    </div>
    <div class="c-post-btn-space"></div>
    <post-button
      ref="btn"
      :initPost="post"
      :title="isExpired ? $T('common.expired') : preparing ? $T('post.file.preparing') : $T('post.file.dl')"
      :disabled="isGuest || isExpired || preparing || loading"
      icon="mdi-download-outline"
      @click="download(0)"
    />
  </div>
</template>

<script>
import postDetailPlugin from '../../utils/plugin/postDetailPlugin';
import { answerPostFile, downloadPostFile } from '../../api/post';

export default {
  mixins: [postDetailPlugin],
  data() {
    return {
      downloading: {},
      loading: false,
    };
  },
  computed: {
    files() {
      return this.post.content.files;
    },
    preparing() {
      return !this.post.content.fixed;
    },
    filenames() {
      var fs = this.files;
      var ns = [];
      for (var k of Object.keys(fs)) ns.push(fs[k]);
      return ns;
    },
  },
  methods: {
    fileName(n) {
      return splitFileName(n)[0];
    },
    fileExt(n) {
      return splitFileName(n)[1];
    },
    download(fid) {
      if (this.isGuest) return;

      var fid = fid ? fid : 0;
      var pid = this.post.id;

      var fileName;
      if (!fid) {
        fileName = this.post.title.replace(/[\\/:*?"<>|]/g, '').trim();
        fileName = fileName == '' ? 'share-file.zip' : `${fileName}.zip`;
      } else {
        fileName = this.files[fid].name;
        var mime = contentType(fileName);
        if (
          [
            'application/pdf',
            'image/jpeg',
            'image/gif',
            'image/png',
            'image/x-icon',
            'video/mp4',
            'video/quicktime',
            'audio/mp4',
            'audio/mpeg',
          ].indexOf(mime) != -1
        ) {
          window.open(`/viewer/post/${pid}/${fid}`, `commin-${mime.split('/')[0]}`).focus();
          return;
        }
      }

      this.startDL(fid);
      var self = this;
      this.$commin.clientdb.getBlob(`post-file-${pid}-${fid}`, blob => {
        if (blob) {
          execDownload(blob, fileName);
          self.endDL(fid);
          return;
        }

        var data = new FormData();
        data.append('pid', pid);

        answerPostFile(data)
          .then(function(post) {
            self.$emit('modified', post);
            self.downloadFromServer(pid, fid, fileName);
          })
          .catch(function(e) {
            console.error('failed to answer post data for pid[' + pid + ']', e);
            self.downloading = false;
            self.errRegisterData();
            self.endDL(fid);
          });
      });
    },
    downloadFromServer(pid, fid, fileName) {
      var mime = contentType(fileName);
      var self = this;
      downloadPostFile(pid, fid, fileName)
        .then(function(data) {
          var blob = new Blob([data], { type: mime });
          execDownload(blob, fileName);
          self.endDL(fid);
          self.$commin.clientdb.putBlob(`post-file-${pid}-${fid}`, blob);
        })
        .catch(function(e) {
          console.error('failed to download post data for pid[' + pid + ']', e);
          self.errGetData();
          self.endDL(fid);
        });
    },
    startDL(fid) {
      this.loading = true;
      if (fid) this.downloading[fid] = true;
      else this.startLoading();
    },
    endDL(fid) {
      this.loading = false;
      if (fid) this.downloading[fid] = false;
      else this.stopLoading();
    },
    toIcon(name) {
      var i = name.lastIndexOf('.');
      if (i == -1 || name.length - 1 == i) return 'mdi-file-outline';
      var ext = name.substr(name.lastIndexOf('.') + 1).toLowerCase();
      var mime = contentType(name);
      if ('pdf' == ext) return 'mdi-file-pdf-box';
      if (['doc', 'docx'].indexOf(ext) != -1 || mime.startsWith('text/')) return 'mdi-file-document-outline';
      if (mime.startsWith('image/')) return 'insert_photo';
      if (mime.startsWith('video/')) return 'mdi-video';
      if (mime.startsWith('audio/')) return 'music_note';
      return 'mdi-file-outline';
    },
  },
};
</script>

<style scoped>
.c-list-ttl {
  margin: 10px 0 5px 0;
  font-size: 16px;
  font-weight: 600;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.28);
  width: 100%;
  text-align: left;
}
.c-btn {
  text-transform: none !important;
  margin: 0 0 0px -5px;
}
.c-fname {
  max-width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.c-fsize {
  margin-left: 5px;
}
</style>
